export class SessionProviderPHP {
  constructor(private readonly apiBaseUrl: string) {
  }
  async login(userEmail: string, userPassword: string) {
    try {
      const response = await fetch(`${this.apiBaseUrl}/api/session`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: userEmail, password: userPassword }),
      });
      if (response.ok) {
        const loginResponse = await response.json();
        console.log("Logged in: ", loginResponse);
        sessionStorage.setItem("userId", loginResponse.id);
        return loginResponse;
      } else {
        console.error("Failed to login", response.statusText);
        return null;
      }
    } catch (error){
      console.error("Error while logging in: ", error);
      return null;
    }
  }

  async logout(){
    try {
      const response = await fetch(`${this.apiBaseUrl}/api/session`, {
        method: "DELETE",
      });
      if (response.ok) {
        sessionStorage.removeItem("userId");
      } else {
        console.error("Not logged in");
      }
    } catch (error){
      console.error("Error: ", error);
    }
  }

  async getUserInfo() {
    try {
      const response = await fetch(`${this.apiBaseUrl}/api/session`);
      if (response.ok) {
        const loginResponse = await response.json();
        console.log("Logged in: ", loginResponse);
        sessionStorage.setItem("userId", loginResponse.id);
        return loginResponse;
      } else {
        console.error("Not logged in");
        return null;
      }
    } catch (error){
      console.error("Error: ", error);
      return null;
    }
  }
}
